import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-plate-database',
  templateUrl: './plate-database.component.html',
  styleUrls: ['./plate-database.component.css']
})

export class PlateDatabaseComponent implements OnInit {
  platedata;
  public location;

  constructor(private _http:HttpClient, private _route: ActivatedRoute) { }

  ngOnInit() {
    this._http.get("http://api.zippopotam.us/").toPromise().then(
      (data) => {
        console.log(data);
      },
      (err) => {console.error("Error",err);}
    );

    //this.zipCode = this._route.snapshot.params['zip'];
    //this.country = this._route.snapshot.params['us'];
      console.log(this._route.snapshot.params['id']);
      this.platedata = {"platesDetected": [
        {
            "plate" : "FSADE-5453",
            "date" : "3/23/2019",
            "violate" : false,
            "messageSent" : false,
            "timeRemaining" : "39"
    
        },
        {
            "plate" : "FS434DE-5453",
            "date" : "3/23/2019",
            "violate" : true,
            "messageSent" : false,
            "timeRemaining" : "0"
    
        },
        {
            "plate" : "FSADE-5453",
            "date" : "3/23/2019",
            "violate" : false,
            "messageSent" : true,
            "timeRemaining" : "10"
    
        },
        {
          "plate" : "F7809324SADE-5453",
          "date" : "3/23/2019",
          "violate" : false,
          "messageSent" : false,
          "timeRemaining" : "120"
  
      },
        ]
    };
      console.log(this.platedata);
  }

  onSubmit(){
    
    console.log("City: " + this.location);
    
    
  }

  dataLog(){
    console.log("Data Log Called");
  }


}
